import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";



import {
  getMaterialList as getMaterialListAction,
  update as updateAction,
} from "../../redux/modules/material";


import { convertImages, fromArrayListKey } from "../../utilities/array";

import UiInputSearch from "../../components/inputs/UiInputSearch";
import UiButtonColor from "../../components/button/UiButtonColor";
import UiModalProductAdd from "../../components/modals/UiModalProductAdd";
import UiPageText from "../../components/text/UiPageText";
import UiTableAdaptive from "../../components/table/UiTableAdaptive";

import "./MaterialsStyle.scss";
import Env from "../../services/Env";
import { storeData } from "../../services/Storage";

function MaterialsPage(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modalDealAddACtive, setModalDealAddActive] = useState(false);
  const [searchLine, setSearchLine] = useState(null);

  const clientsTitles = [
    { sort: false, title: "" },
    { sort: false, title: "" },
    { sort: false, title: "" },
    { sort: true, title: "Номер" },
    { sort: false, title: "Название" },
    { sort: false, title: "Описание" }, 
    
    { sort: false, title: "Скрыть" },
    { sort: false, title: "Удалить" },
  ];
  const [tableListOrders, setTableListOrders] = useState([]);

  useEffect(() => { 
    props.getMaterialList();
  }, []);

  useEffect(() => {
    let arr = [];
    if(props.material.list.length > 0){
      props.material.list.map((item) => {
        let images = convertImages(item.imgs);
        item.images = images;
        arr.push([
          {
            inputSort: `${item.sort}`,
            onBlurInput: (v) => {
              let _item = item;
              let s = _item.sort;
              if(v == 1 ){
                s++;
                _item.sort = s;
              } else {
                s--;
                _item.sort = s;
              } 
              props.update(_item).then(() => props.getMaterialList());
            },
          },
          {
            button: "edit", onClick: () => {
              storeData("edit", item)
              navigate("/material/add");
            }
          },
          { image: item.image ? Env.PUBLIC_URL + item.image : null },
          { text: item.id },
          { text: item.title },
          { text: item.text },
    
          
          {
            button: item.is_active == 0 ? "eye-open" : "eye", onClick: () => {
              let _item = item;
              _item.is_active = item.is_active == 1 ? 0 : 1;
              props.update(_item);
            }
          },
          {
            button: item.is_del == 0 ? "delete" : "delete", onClick: () => {
              let _item = item;
              _item.is_del = 1;
              props.update(_item);
            }
          },
        ])
      })
      setTableListOrders(arr);
    }

  }, [props.material.list]);

  return (
    <div id="page" className="home-page">
      <section className="home-info ui-grid">
        <div className="home-info-text">
          <UiPageText title="Список материалов" />
        </div>
        <div className="home-info-button">
          <UiButtonColor
            color="primary"
            text="Добавить"
            small={true}
            onClick={() => {
              storeData("edit", null);
              navigate("/material/add");
            }}
          />
        </div>
      </section>
      <section className="page-content">
        <div className="page-search">
          <UiInputSearch
            label="Список"
            placeholder="Поиск:"
            onChange={(val) => setSearchLine(val)}
          />
        </div>

        <UiTableAdaptive
          titleList={clientsTitles}
          grid={clientsTitles.length}
          tableList={tableListOrders}
          search={searchLine}
        />
      </section>

    </div>
  );
}

export default connect(
  ({ material }) => ({
    material,
  }),
  {
    getMaterialList: getMaterialListAction,
    update: updateAction,


  }
)(MaterialsPage);
